(function () {
  'use strict';

  if (window.__ugIfaBooted) return;
  window.__ugIfaBooted = true;

  var ECF_ENDPOINT = 'https://ecf.cirkleinc.com/api/form-submit';
  var MOBILE_MQ = '(max-width: 1023.98px)';
  var REDUCE_MQ = '(prefers-reduced-motion: reduce)';

  /**
   * @param {HTMLVideoElement} video
   */
  function primeVideo(video) {
    try {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('x5-playsinline', '');
    } catch (_) {}
  }

  /**
   * @param {HTMLVideoElement} video
   */
  function playVideo(video) {
    primeVideo(video);
    var run = function () {
      try {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (_) {}
    };
    if (video.readyState >= 2) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(run);
      });
      return;
    }
    video.addEventListener('loadeddata', run, { once: true });
    video.addEventListener('canplay', run, { once: true });
    try {
      video.load();
    } catch (_) {}
  }

  /**
   * @param {HTMLElement} root
   */
  function syncKvVideo(root) {
    var kv = root.querySelector('[data-ifa-kv]');
    if (!(kv instanceof HTMLElement)) return;

    var poster = kv.querySelector('.ug-ifa-kv__poster');
    var reduced = window.matchMedia(REDUCE_MQ).matches;
    var isMobile = window.matchMedia(MOBILE_MQ).matches;
    var pcVideo = kv.querySelector('.ug-ifa-kv__video--pc');
    var mbVideo = kv.querySelector('.ug-ifa-kv__video--mb');
    var active = isMobile ? mbVideo || pcVideo : pcVideo || mbVideo;
    var inactive = active === pcVideo ? mbVideo : pcVideo;

    if (inactive instanceof HTMLVideoElement) {
      try {
        inactive.pause();
      } catch (_) {}
      inactive.classList.remove('is-visible');
    }

    if (reduced || !(active instanceof HTMLVideoElement)) {
      if (poster instanceof HTMLElement) poster.classList.remove('is-hidden');
      return;
    }

    var source = active.querySelector('source');
    var src = source ? source.getAttribute('src') : active.getAttribute('src');
    if (!src || !String(src).trim()) {
      if (poster instanceof HTMLElement) poster.classList.remove('is-hidden');
      return;
    }

    var reveal = function () {
      active.classList.add('is-visible');
      if (poster instanceof HTMLElement) poster.classList.add('is-hidden');
      playVideo(active);
    };

    if (active.readyState >= 3) {
      reveal();
    } else {
      active.addEventListener('canplay', reveal, { once: true });
      active.addEventListener('loadeddata', reveal, { once: true });
      try {
        active.preload = 'auto';
        active.load();
      } catch (_) {}
    }
  }

  /**
   * @param {HTMLFormElement} form
   * @param {boolean} isLoading
   */
  function setFormLoading(form, isLoading) {
    var submitBtn = form.querySelector('button[type="submit"]');
    if (!(submitBtn instanceof HTMLButtonElement)) return;
    submitBtn.disabled = isLoading;
    submitBtn.classList.toggle('is-loading', isLoading);
  }

  /**
   * @param {HTMLFormElement} form
   */
  function bindForm(form) {
    if (!(form instanceof HTMLFormElement)) return;
    if (form.dataset.ugIfaBound === '1') return;
    form.dataset.ugIfaBound = '1';

    var emailInput = form.querySelector('input[type="email"]');
    var checkbox = form.querySelector('input[type="checkbox"]');
    var successMessage = form.querySelector('[data-message="success"]');
    var errorMessage = form.querySelector('[data-message="error"]');
    var defaultSuccess = form.dataset.successMessage || '';
    var defaultError = form.dataset.errorMessage || '';
    var termsError = form.dataset.termsError || 'Please agree to the terms.';

    function hideMessages() {
      if (successMessage instanceof HTMLElement) successMessage.hidden = true;
      if (errorMessage instanceof HTMLElement) errorMessage.hidden = true;
    }

    /**
     * @param {HTMLElement | null} target
     * @param {string} text
     */
    function showMessage(target, text) {
      if (!(target instanceof HTMLElement)) return;
      target.hidden = false;
      target.textContent = text;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      hideMessages();

      var emailValue = emailInput instanceof HTMLInputElement ? emailInput.value.trim() : '';
      if (
        !emailValue ||
        (emailInput instanceof HTMLInputElement && emailInput.validity.typeMismatch)
      ) {
        showMessage(errorMessage, defaultError || 'Please enter a valid email address.');
        if (emailInput instanceof HTMLInputElement) emailInput.focus();
        return;
      }

      if (checkbox instanceof HTMLInputElement && !checkbox.checked) {
        showMessage(errorMessage, termsError);
        checkbox.focus();
        return;
      }

      setFormLoading(form, true);

      var payload = {
        email: emailValue,
        accepts_marketing: checkbox instanceof HTMLInputElement && checkbox.checked ? 'on' : 'off',
        form_id: form.dataset.formId || ''
      };

      var ecfTag = String(form.dataset.ecfTag || '').trim();
      if (ecfTag) payload.tag = ecfTag;

      fetch(ECF_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data && data.status === 'success') {
            if (emailInput instanceof HTMLInputElement) emailInput.value = '';
            if (checkbox instanceof HTMLInputElement) checkbox.checked = false;
            showMessage(successMessage, defaultSuccess || data.message || 'Thanks! You are signed up.');
            return;
          }

          var apiError =
            (data && data.errors && data.errors.email && data.errors.email[0]) ||
            (data && data.message) ||
            defaultError ||
            'Sign-up failed. Please try again later.';
          showMessage(errorMessage, apiError);
        })
        .catch(function (err) {
          console.error('UG IFA ECF error:', err);
          showMessage(errorMessage, defaultError || 'Sign-up failed. Please try again later.');
        })
        .finally(function () {
          setFormLoading(form, false);
        });
    });
  }

  /**
   * @param {HTMLElement} section
   */
  function bindBrief(section) {
    if (!(section instanceof HTMLElement)) return;
    if (section.dataset.ugIfaBriefBound === '1') return;
    section.dataset.ugIfaBriefBound = '1';

    var reduced = window.matchMedia(REDUCE_MQ).matches;
    var pcVideo = section.querySelector('.ug-ifa-brief__video--pc');
    var mbVideo = section.querySelector('.ug-ifa-brief__video--mb');

    /**
     * @returns {HTMLVideoElement | null}
     */
    function activeVideo() {
      var isMobile = window.matchMedia(MOBILE_MQ).matches;
      var chosen = isMobile ? mbVideo || pcVideo : pcVideo || mbVideo;
      return chosen instanceof HTMLVideoElement ? chosen : null;
    }

    /**
     * @param {HTMLVideoElement | null} video
     * @returns {string}
     */
    function videoSrc(video) {
      if (!(video instanceof HTMLVideoElement)) return '';
      var source = video.querySelector('source');
      var src = source ? source.getAttribute('src') : video.getAttribute('src');
      return src ? String(src).trim() : '';
    }

    /**
     * @param {HTMLVideoElement} video
     */
    function holdLastFrame(video) {
      try {
        var duration = video.duration;
        if (isFinite(duration) && duration > 0) {
          video.currentTime = Math.max(0, duration - 0.05);
        }
        video.pause();
      } catch (_) {}
    }

    /**
     * @param {HTMLVideoElement | null} [keepVideo]
     */
    function settle(keepVideo) {
      section.classList.add('is-settled');
      section.classList.remove('is-playing');
      [pcVideo, mbVideo].forEach(function (video) {
        if (!(video instanceof HTMLVideoElement)) return;
        if (keepVideo && video === keepVideo) {
          holdLastFrame(video);
          video.classList.add('is-active');
          return;
        }
        try {
          video.pause();
        } catch (_) {}
        video.classList.remove('is-active');
      });
    }

    /**
     * @param {HTMLVideoElement | null} video
     */
    function watchFinish(video) {
      if (!(video instanceof HTMLVideoElement)) return;
      if (video.dataset.ugIfaFinishBound === '1') return;
      video.dataset.ugIfaFinishBound = '1';
      video.addEventListener('ended', function () {
        settle(video);
      });
      video.addEventListener('error', function () {
        settle();
      });
    }

    /**
     * @param {HTMLVideoElement | null} video
     */
    function activateVideo(video) {
      [pcVideo, mbVideo].forEach(function (other) {
        if (!(other instanceof HTMLVideoElement) || other === video) return;
        try {
          other.pause();
        } catch (_) {}
        other.classList.remove('is-active');
      });

      if (!(video instanceof HTMLVideoElement) || !videoSrc(video)) {
        settle();
        return false;
      }

      section.classList.add('is-playing');
      video.classList.add('is-active');
      watchFinish(video);
      playVideo(video);
      return true;
    }

    function syncForViewport() {
      reduced = window.matchMedia(REDUCE_MQ).matches;
      if (reduced) {
        settle();
        return;
      }

      var video = activeVideo();
      if (section.classList.contains('is-settled')) {
        if (video && videoSrc(video)) settle(video);
        else settle();
        return;
      }

      if (!section.classList.contains('is-playing')) return;
      if (
        video instanceof HTMLVideoElement &&
        video.classList.contains('is-active') &&
        !video.paused
      ) {
        return;
      }
      activateVideo(video);
    }

    function playIntro() {
      if (section.classList.contains('is-settled') || section.classList.contains('is-playing')) return;

      if (reduced) {
        settle();
        return;
      }

      activateVideo(activeVideo());
    }

    section._ugIfaBriefSync = syncForViewport;

    if (reduced || !videoSrc(activeVideo())) {
      settle();
      return;
    }

    var rect = section.getBoundingClientRect();
    var mid = window.innerHeight * 0.5;
    if (rect.top < mid) {
      if (rect.bottom > 0) playIntro();
      else settle();
      return;
    }

    if (typeof IntersectionObserver === 'undefined') {
      playIntro();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          playIntro();
          io.disconnect();
        });
      },
      { threshold: 0, rootMargin: '0px 0px -50% 0px' }
    );
    io.observe(section);
  }

  /**
   * @param {HTMLElement} box
   */
  function bindExhibit(box) {
    if (!(box instanceof HTMLElement)) return;
    if (box.dataset.ugIfaExhibitBound === '1') return;
    box.dataset.ugIfaExhibitBound = '1';

    var track = box.querySelector('[data-ifa-exhibit-track]');
    var viewport = box.querySelector('[data-ifa-exhibit-viewport]');
    var slides = box.querySelectorAll('[data-ifa-slide]');
    var prev = box.querySelector('[data-ifa-prev]');
    var next = box.querySelector('[data-ifa-next]');
    var last = slides.length - 1;
    var index = 0;
    var startX = 0;
    var dragging = false;
    var reduced = window.matchMedia(REDUCE_MQ).matches;

    function lightUp() {
      if (box.classList.contains('is-lit')) return;
      box.classList.add('is-lit');
    }

    function watchEnter() {
      if (reduced) {
        lightUp();
        return;
      }

      var rect = box.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.52 && rect.bottom > window.innerHeight * 0.2) {
        lightUp();
        return;
      }

      if (typeof IntersectionObserver === 'undefined') {
        lightUp();
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            lightUp();
            io.disconnect();
          });
        },
        { threshold: 0.32, rootMargin: '0px 0px -22% 0px' }
      );
      io.observe(box);
    }

    if (slides.length < 2) {
      box.classList.add('is-single');
      watchEnter();
      return;
    }

    /**
     * @param {number} nextIndex
     */
    function go(nextIndex) {
      index = Math.max(0, Math.min(last, nextIndex));
      if (track instanceof HTMLElement) {
        track.style.transform = 'translate3d(' + -index * 100 + '%,0,0)';
      }
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      box.dataset.index = String(index);
      if (prev instanceof HTMLButtonElement) prev.disabled = index <= 0;
      if (next instanceof HTMLButtonElement) next.disabled = index >= last;
    }

    if (prev instanceof HTMLButtonElement) {
      prev.addEventListener('click', function () {
        go(index - 1);
      });
    }
    if (next instanceof HTMLButtonElement) {
      next.addEventListener('click', function () {
        go(index + 1);
      });
    }

    if (viewport instanceof HTMLElement) {
      viewport.addEventListener(
        'pointerdown',
        function (event) {
          dragging = true;
          startX = event.clientX;
        },
        { passive: true }
      );
      viewport.addEventListener(
        'pointerup',
        function (event) {
          if (!dragging) return;
          dragging = false;
          var delta = event.clientX - startX;
          if (delta > 40) go(index - 1);
          else if (delta < -40) go(index + 1);
        },
        { passive: true }
      );
      viewport.addEventListener('pointercancel', function () {
        dragging = false;
      });
    }

    go(0);
    watchEnter();
  }

  /**
   * @param {HTMLElement} box
   */
  function bindCopy(box) {
    if (!(box instanceof HTMLElement)) return;
    if (box.dataset.ugIfaCopyBound === '1') return;
    box.dataset.ugIfaCopyBound = '1';

    var reduced = window.matchMedia(REDUCE_MQ).matches;
    var text = box.querySelector('[data-ifa-copy-text]');
    var more = box.querySelector('[data-ifa-copy-more]');

    function syncMore() {
      if (!(text instanceof HTMLElement) || !(more instanceof HTMLElement)) return;
      if (box.classList.contains('is-open')) return;
      more.hidden = text.scrollHeight <= text.clientHeight + 2;
    }

    function expand() {
      if (!(text instanceof HTMLElement) || !(more instanceof HTMLElement)) return;
      if (box.classList.contains('is-open')) return;

      more.setAttribute('aria-expanded', 'true');

      if (window.matchMedia(REDUCE_MQ).matches) {
        box.classList.add('is-open');
        return;
      }

      var from = text.getBoundingClientRect().height;
      var to = text.scrollHeight;
      text.style.maxHeight = from + 'px';
      text.style.overflow = 'hidden';
      box.classList.add('is-open');
      text.offsetHeight;
      text.style.transition = 'max-height 0.7s ease';
      text.style.maxHeight = to + 'px';

      var done = function (event) {
        if (event && event.propertyName && event.propertyName !== 'max-height') return;
        text.style.maxHeight = '';
        text.style.overflow = '';
        text.style.transition = '';
        text.removeEventListener('transitionend', done);
      };
      text.addEventListener('transitionend', done);
    }

    if (more instanceof HTMLElement) {
      more.addEventListener('click', expand);
    }

    function reveal() {
      if (box.classList.contains('is-in')) return;
      box.classList.add('is-in');
      window.requestAnimationFrame(syncMore);
    }

    window.addEventListener(
      'resize',
      function () {
        window.requestAnimationFrame(syncMore);
      },
      { passive: true }
    );
    window.requestAnimationFrame(syncMore);

    if (reduced) {
      reveal();
      return;
    }

    var rect = box.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.78 && rect.bottom > 0) {
      reveal();
      return;
    }

    if (typeof IntersectionObserver === 'undefined') {
      reveal();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal();
          io.disconnect();
        });
      },
      { threshold: 0.28, rootMargin: '0px 0px -10% 0px' }
    );
    io.observe(box);
  }

  /**
   * @param {HTMLElement} box
   */
  function bindMoments(box) {
    if (!(box instanceof HTMLElement)) return;
    if (box.dataset.ugIfaMomentsBound === '1') return;
    box.dataset.ugIfaMomentsBound = '1';

    var track = box.querySelector('[data-ifa-moments-track]');
    var viewport = box.querySelector('[data-ifa-moments-viewport]');
    var slides = box.querySelectorAll('[data-ifa-moments-slide]');
    var dots = box.querySelectorAll('[data-ifa-moments-dot]');
    var prev = box.querySelector('[data-ifa-moments-prev]');
    var next = box.querySelector('[data-ifa-moments-next]');
    var last = slides.length - 1;
    var index = 0;
    var startX = 0;
    var dragging = false;

    if (!(track instanceof HTMLElement) || slides.length < 1) return;

    function metrics() {
      var slide = slides[0];
      var width = slide instanceof HTMLElement ? slide.getBoundingClientRect().width : 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return { width: width, gap: gap };
    }

    /**
     * @param {number} nextIndex
     */
    function go(nextIndex) {
      index = Math.max(0, Math.min(last, nextIndex));
      var size = metrics();
      track.style.transform = 'translate3d(' + -index * (size.width + size.gap) + 'px,0,0)';
      box.dataset.index = String(index);
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      if (prev instanceof HTMLButtonElement) prev.disabled = index <= 0;
      if (next instanceof HTMLButtonElement) next.disabled = index >= last;
    }

    if (prev instanceof HTMLButtonElement) {
      prev.addEventListener('click', function () {
        go(index - 1);
      });
    }
    if (next instanceof HTMLButtonElement) {
      next.addEventListener('click', function () {
        go(index + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var nextIndex = parseInt(dot.getAttribute('data-index') || '0', 10);
        if (!isNaN(nextIndex)) go(nextIndex);
      });
    });

    if (viewport instanceof HTMLElement && slides.length > 1) {
      viewport.addEventListener(
        'pointerdown',
        function (event) {
          dragging = true;
          startX = event.clientX;
        },
        { passive: true }
      );
      viewport.addEventListener(
        'pointerup',
        function (event) {
          if (!dragging) return;
          dragging = false;
          var delta = event.clientX - startX;
          if (delta > 40) go(index - 1);
          else if (delta < -40) go(index + 1);
        },
        { passive: true }
      );
      viewport.addEventListener('pointercancel', function () {
        dragging = false;
      });
    }

    window.addEventListener(
      'resize',
      function () {
        go(index);
      },
      { passive: true }
    );

    go(0);
  }

  /**
   * @param {Element} root
   */
  function bindSection(root) {
    if (!root) return;
    syncKvVideo(root);
    root.querySelectorAll('[data-ifa-brief]').forEach(bindBrief);
    root.querySelectorAll('[data-ifa-exhibit]').forEach(bindExhibit);
    root.querySelectorAll('[data-ifa-copy]').forEach(bindCopy);
    root.querySelectorAll('[data-ifa-moments]').forEach(bindMoments);
    root.querySelectorAll('.ug-ifa-kv__form').forEach(bindForm);

    if (root.dataset.ugIfaResizeBound === '1') return;
    root.dataset.ugIfaResizeBound = '1';

    var resizeTimer = 0;
    window.addEventListener(
      'resize',
      function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          syncKvVideo(root);
          root.querySelectorAll('[data-ifa-brief]').forEach(function (brief) {
            if (typeof brief._ugIfaBriefSync === 'function') brief._ugIfaBriefSync();
          });
        }, 150);
      },
      { passive: true }
    );
  }

  function init() {
    document.querySelectorAll('[data-ug-ifa]').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!(event.target instanceof Element)) return;
    if (event.target.matches('[data-ug-ifa]')) bindSection(event.target);
    event.target.querySelectorAll('[data-ug-ifa]').forEach(bindSection);
  });
})();
